export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/authWorker.c28764e2.worker.js");
}
